import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteConfig } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2.5 group">
            <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-compass-3-line text-lg text-background-50"></i>
            </div>
            <span className={`font-semibold text-lg transition-colors ${
              scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
            }`}>
              {siteConfig.siteName}
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled || !isHome
                    ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200/70'
                    : 'text-background-50/80 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about#contact"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                scrolled || !isHome
                  ? 'text-foreground-600 hover:text-foreground-900'
                  : 'text-background-50/70 hover:text-background-50'
              }`}
            >
              登录
            </Link>
            <Link
              to="/#pricing"
              className="px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              免费开始
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled || !isHome
                ? 'text-foreground-800 hover:bg-background-200'
                : 'text-background-50 hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                {link.label}
              </Link>
            ))}
            <div className="border-t border-background-200/70 mt-2 pt-3 flex flex-col gap-2">
              <Link
                to="/about#contact"
                className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-600 hover:text-foreground-900 hover:bg-background-100 transition-colors whitespace-nowrap"
              >
                登录
              </Link>
              <Link
                to="/#pricing"
                className="px-4 py-3 rounded-lg text-sm font-semibold text-center bg-primary-500 hover:bg-primary-600 text-background-50 transition-colors whitespace-nowrap"
              >
                免费开始
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}